module.exports = __webpack_public_path__ + "10.svg?5773d2fac489727bdbb27ef5c6c9dd97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/10.svg
// module id = 69
// module chunks = 0